import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CoreComponent } from '../core/core.component.js';

@Component({
	selector: 'ui-form-field-layout',
	templateUrl: './form-field-layout.component.html',
	styleUrls: ['./form-fields.shared.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class FormFieldLayoutComponent extends CoreComponent {
	public readonly title = input<string>();
	public readonly subtitle = input<string>();
	public readonly hint = input<string>();
	public readonly isValid = input<boolean>(false);
	public readonly isRequired = input<boolean>();
	public readonly suffix = input<string>();

	constructor() {
		super();
	}
}
